enum BufferingType {
    NONE = 'NONE',
    NETWORK = 'NETWORK',
    SEEK = 'SEEK'
}

export default BufferingType;